module.exports = __webpack_public_path__ + "static/img/8.3017617a.png";